import {Box, withShade} from '@dropbox/dig-foundations';
import {DocumentThread} from 'client';
import {ThreadBox} from 'components/DSYS/editor/plugins/comments/CommentBox';
import {useDocumentThreadService} from 'components/DSYS/editor/plugins/comments/useThreads';
import {forwardRef} from 'react';

type PlanningCommentThreadProps = {
  thread: DocumentThread;
  isSelected: boolean;
  onThreadSelect: () => void;
};

export const PlanningCommentThread = forwardRef<HTMLDivElement, PlanningCommentThreadProps>(
  ({thread, isSelected, onThreadSelect}, ref) => {
    const {updateThread} = useDocumentThreadService();

    if (!thread.comments?.some((comment) => !comment.is_deleted)) {
      return null;
    }
    const isPrivate = Boolean(thread.private_employees?.length || thread.private_teams?.length);

    const handleResolveClick = async (isResolved: boolean) => {
      try {
        await updateThread({threadId: thread.id, data: {...thread, is_resolved: isResolved}});
      } catch {
        // Intentionally no-op: keep UI state unchanged if the mutation fails.
      }
    };

    return (
      <Box
        ref={ref}
        borderRadius="Medium"
        cursor="pointer"
        onClick={onThreadSelect}
        paddingX="16"
        paddingY="12"
        backgroundColor={isSelected ? 'Background Subtle' : undefined}
        borderColor={isPrivate ? 'Secondary Base' : undefined}
        borderStyle={isPrivate ? 'Solid' : undefined}
        borderWidth={isPrivate ? '2' : undefined}
        data-planning-drawer-thread-id={thread.id}
        {...withShade({})}
      >
        <ThreadBox thread={thread} onResolveClick={handleResolveClick} truncateLines={4} />
      </Box>
    );
  }
);

PlanningCommentThread.displayName = 'PlanningCommentThread';
